"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = W2ReadyMessage;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const Message_1 = __importDefault(require("../components/Message"));
const cancelable_promise_1 = require("cancelable-promise");
const Taxes_1 = __importDefault(require("../api/Taxes"));
const UserContext_1 = require("../contexts/UserContext");
const Helper_1 = require("../Helper");
const Files_1 = require("../shared/Files");
const react_i18next_1 = require("react-i18next");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
function W2ReadyMessage(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [year, setYear] = react_1.default.useState(null);
    const [hasPriorYearPaystubs, setHasPriorYearPaystubs] = react_1.default.useState(true);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => Taxes_1.default.getDocuments(token))).then(data => {
            setHasPriorYearPaystubs(data?.hasPriorYearPaystubs ?? true);
            if (data != null && data.yearsW2?.length > 0) {
                setYear(data.yearsW2[0]);
            }
            else {
                setYear(null);
            }
        }).catch(e => {
            setHasPriorYearPaystubs(true);
            setYear(null);
        });
    }, []);
    const getFileUrl = (action) => {
        promise.current[action]?.cancel();
        promise.current[action] = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Taxes_1.default.getW2Download(token, year))).then((data) => data.url);
        return promise.current[action];
    };
    const getDownload = () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Download W2',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        return getFileUrl("save").then((url) => {
            let name = "Nextep_" + year + "_W2" + ".pdf";
            return Files_1.Files.SaveToDownloads(name, "application/pdf", url);
        });
    };
    const viewFile = (url) => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'View W2',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        react_native_1.DeviceEventEmitter.addListener("event.downloadPdf", () => {
            getDownload().then(() => showSnackbar(true)).catch(() => showSnackbar(false));
        });
        props.navigation.navigate('PdfScreen', { uri: url, title: year + ' W2', canDownload: true });
    };
    const showSnackbar = (success) => {
        react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: success ? "success" : "error", message: success ? t('myPay:messages.downloaded') : t('myPay:messages.downFail') });
    };
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
            react_native_1.DeviceEventEmitter.removeAllListeners("event.downloadPdf");
        };
    }, []);
    const currentYear = new Date().getFullYear();
    const priorYear = String(currentYear - 1);
    const currentMonth = new Date().getMonth();
    const currentDay = new Date().getDate();
    const beforeTaxDeadline = currentMonth < 3 || (currentMonth == 3 && currentDay < 16);
    const w2Ready = hasPriorYearPaystubs && year === priorYear && beforeTaxDeadline;
    const w2InProgress = hasPriorYearPaystubs && currentMonth === 0 && year !== priorYear;
    return (w2Ready
        &&
            (0, jsx_runtime_1.jsx)(Message_1.default, { indicator: 'secondary', onActionStart: Helper_1.Helper.isPlatformWeb ? () => getDownload() : () => getFileUrl('view'), onActionComplete: Helper_1.Helper.isPlatformWeb ? () => showSnackbar(true) : (url) => viewFile(url), onActionError: () => showSnackbar(false), actionText: Helper_1.Helper.isPlatformWeb ? t('common:buttons.download') : t('common:buttons.view'), content: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { accessible: false, onPress: () => react_native_1.Linking.openURL('https://www.nextep.com/resources/faq/#your-taxes'), style: {
                        color: THEME.Text,
                        marginLeft: 10,
                        fontSize: 12,
                        textAlignVertical: 'center'
                    }, children: [t('myPay:messages.w2Ready'), "\u00A0", (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontWeight: '500' }, children: t('myPay:messages.resources') }), "."] }) })
        ||
            (w2InProgress &&
                (0, jsx_runtime_1.jsx)(Message_1.default, { indicator: 'secondary', content: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: {
                            color: THEME.Text,
                            marginLeft: 10,
                            fontSize: 12,
                            textAlignVertical: 'center'
                        }, children: t('myPay:messages.w2InProgress') }) })));
}
;
